// disabling since this is the util that other files depend on
// oxlint-disable eslint-js/no-restricted-syntax
import { routes } from '@shared/constants/routes'

type ProductUrlParams =
  | {
      id: number
      universal_id: string | undefined
      ungated?: boolean
    }
  | {
      id?: number
      universal_id: string
      ungated: true
    }

/**
 * Please use this util to ensure all future product links follow the correct URL format
 */
export const getProductPageUrl = ({ id, universal_id, ungated }: ProductUrlParams) => {
  if (ungated) {
    return `${routes.PRODUCT.url}/${universal_id}`
  }

  return `${routes.PRODUCT.url}/${universal_id ? universal_id + '/' : ''}${id}`
}
